document.addEventListener('DOMContentLoaded', () => {
  const gridModules = document.querySelectorAll('.a-grid-three-columns')

  gridModules.forEach((gridModule) => {
    const grid = gridModule.querySelector('.grid-section')
    const tiles = grid.querySelectorAll('.tile')

    setSquare(tiles)

    window.addEventListener('resize', () => {
      setSquare(tiles)
    })
  })
})

function setSquare (tiles) {
  tiles.forEach((tile) => {
    const width = tile.offsetWidth
    if (width) {
      tile.style.height = Math.round(tile.offsetWidth) + 'px'
    }
  })
}
